// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum LogLevel {
	Trace = 0,
	Debug = 1,
	Information = 2,
	Warning = 3,
	Error = 4,
	Critical = 5,
	None = 6,
}

export const LogLevelDisplayNames: { [key in keyof typeof LogLevel]?: string} = {
	"Trace": "Trace",
	0 : "Trace",
	"Debug": "Debug",
	1 : "Debug",
	"Information": "Information",
	2 : "Information",
	"Warning": "Warning",
	3 : "Warning",
	"Error": "Error",
	4 : "Error",
	"Critical": "Critical",
	5 : "Critical",
	"None": "None",
	6 : "None",
}

export const getLogLevelDisplayName = (key: LogLevel | (keyof typeof LogLevel & string)) => {
	return LogLevelDisplayNames[key];
}

